import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable()
export abstract class IWorkbookLogService {
    //WorkbookLog results are dynamic, so it is not returning any typed data model
    abstract getWorkbookLogs(jobNumber: string): Observable<any[]>;
    abstract addWorkbookLog(workbookLogToAdd: any): Observable<any>;
    abstract updateWorkBookLog(clientId:string, workbookLogToUpdate: any): Observable<any>;
}